import React, { useState, useMemo } from 'react';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';
import { Tooltip } from 'antd';
import { Bot } from 'lucide-react';
import BotModal from './BotModal';

const BOT_PERMISSION_CODE = 1201;

function hasBotPermission() {
    try {
        const raw = localStorage.getItem('permissions');
        if (!raw || raw === 'undefined') return false;
        const arr = JSON.parse(raw);
        if (!Array.isArray(arr)) return false;
        return arr.includes(BOT_PERMISSION_CODE);
    } catch (e) {
        return false;
    }
}

export default function BotFloatButton() {
    const [open, setOpen] = useState(false);
    const allowed = useMemo(() => hasBotPermission(), []);

    if (!allowed) return null;

    return (
        <Nav pullLeft>
            <NavItem eventKey={15.3} onClick={() => setOpen(true)}>
                <Tooltip title="AI 助手">
                    <Bot size={16} strokeWidth={1.75} style={{ verticalAlign: '-0.2em' }} />
                </Tooltip>
            </NavItem>
            <BotModal open={open} onClose={() => setOpen(false)} />
        </Nav>
    );
}
